import { render, staticRenderFns } from "./NotificationFilters.vue?vue&type=template&id=1786a6a6&scoped=true"
import script from "./NotificationFilters.vue?vue&type=script&lang=js"
export * from "./NotificationFilters.vue?vue&type=script&lang=js"
import style0 from "./NotificationFilters.vue?vue&type=style&index=0&id=1786a6a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1786a6a6",
  null
  
)

export default component.exports